module.exports = __webpack_public_path__ + "resources/img/main_banner_gov05.1d94dd14ddf8c6f1ffc15479da8e396d.png";